import { createSlice } from "@reduxjs/toolkit";

export const userDataSlice = createSlice({
  name: "userData",
  initialState: {
    data: null,
    error: null,
    isLoading: false
  },
  reducers: {
    startUserData: (state) => { state.isLoading = true; },
    setUserData: (state, {payload: { data = null, error = null }}) => {
      state.data = data;
      state.error = error;
      state.isLoading = false;
    }
  }
});

export const { startUserData, setUserData } = userDataSlice.actions;
